export default __webpack_public_path__ + "static/media/broken-screen.6317c038.svg";